import { TemplateType } from '~/types/template';

export const PAGE_NOT_FOUND_TITLE: Partial<
  Record<
    TemplateType,
    {
      pluralLabel: string;
      singularLabel: string;
    }
  >
> = {
  [TemplateType.COLLECTION]: {
    pluralLabel: 'collection',
    singularLabel: 'collection',
  },
  [TemplateType.PRODUCT]: {
    pluralLabel: 'products',
    singularLabel: 'product',
  },
  [TemplateType.ARTICLE]: {
    pluralLabel: 'blog post',
    singularLabel: 'blog post',
  },
  [TemplateType.PAGE]: {
    pluralLabel: 'pages',
    singularLabel: 'page',
  },
};

export const ASSIGNED_PAGE_IS_SELECT_MULTIPLE = [TemplateType.COLLECTION, TemplateType.PRODUCT];
